define('lq/ajax',[
    'jquery'
], function($) {

    // for now we retry all non-successful requests that are not in this list
    // an alternative approach is to retry only requests for which jqXHR.status === 0 (so for which we did not receive a response from the server)
    const ignoredStatuses= [500,401];

    const withRetry = function(options, retries = 3, delay = 200) {
        options = options || {};

        return $.Deferred(function (deferred) {
            function attempt(remainingRetries, currentDelay) {
                // global: false => we are going to trigger the global ajaxError-event manually (and only after the last failed try)
                const ajaxOptions = $.extend({}, options, { global: false });

                var xhr = $.ajax(ajaxOptions)
                    .done(function (data, textStatus, jqXHR) {
                        deferred.resolve(data, textStatus, jqXHR);
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        if (ignoredStatuses.indexOf(jqXHR.status) !== -1 || jqXHR.statusText === 'abort') {
                            $(document).trigger('ajaxError', [jqXHR, options, errorThrown]);
                            deferred.reject(jqXHR, textStatus, errorThrown);
                        } else if (remainingRetries > 0) {
                            setTimeout(function () {
                                attempt(remainingRetries - 1, currentDelay * 2);
                            }, currentDelay);
                        } else {
                            $(document).trigger('ajaxError', [jqXHR, options, errorThrown]);
                            deferred.reject(jqXHR, textStatus, errorThrown);
                        }
                    });

                if (options.signal) {
                    if (options.signal.aborted) {
                        xhr.abort();
                    } else {
                        var abortRequest = ()=> xhr.abort();

                        options.signal.addEventListener("abort", abortRequest);

                        xhr.always(function() {
                            options.signal.removeEventListener("abort", abortRequest);
                        });                        
                    }                    
                }
            }

            attempt(retries, delay);
        }).promise();
    };

    return {
        withRetry: withRetry
    };
});

